import React, { useEffect, useRef } from 'react';
import cars1 from './images/img1.png';
import cars2 from './images/img2.png';

import cars4 from './images/img3.png';
import cars5 from './images/img4.png';

import { FaWhatsapp } from 'react-icons/fa';

import gsap from 'gsap';

const carsData = [
  {
    id: 1,
    image: cars2,
    title: 'Honda Civic',
    price: '$9120',
    subtitle:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Atque, aliquam harum blanditiis, minus quasi fuga soluta culpa itaque ratione vero vitae aperiam a ea fugiat molestias. Repellat nulla corrupti iure?',
    modal: 'Modal 3rd ',
    BgColor: '#828282',
  },
  {
    id: 2,
    image: cars1,
    title: 'Honda Accord',
    price: '$1120',
    subtitle:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Atque, aliquam harum blanditiis, minus quasi fuga soluta culpa itaque ratione vero vitae aperiam a ea fugiat molestias. Repellat nulla corrupti iure?',
    modal: 'Modal 2nd ',
    BgColor: '#343232',
  },
  {
    id: 4,
    image: cars4,
    title: 'Honda CR-V',
    price: '$1800',
    subtitle:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Atque, aliquam harum blanditiis, minus quasi fuga soluta culpa itaque ratione vero vitae aperiam a ea fugiat molestias. Repellat nulla corrupti iure?',
    modal: 'Modal 4',
    BgColor: '#a2a0a5',
  },
  {
    id: 5,
    image: cars5,
    title: 'Honda Odyssey',
    price: '$7500',
    subtitle:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Atque, aliquam harum blanditiis, minus quasi fuga soluta culpa itaque ratione vero vitae aperiam a ea fugiat molestias. Repellat nulla corrupti iure?',
    modal: 'Modal 4',
    BgColor: '#ff646a',
  },
];

const Hero = () => {
  const [activeData, setActiveData] = React.useState(carsData[0]);

  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const buttonRef = useRef(null);
  const floatingCardRef = useRef(null);
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const CircleRef = useRef(null);


  const handleActiveData = (data) => {
    setActiveData(data);
  };

  useEffect(() => {
    // GSAP Timeline for Sequenced Animations
    const tl = gsap.timeline();

    // Animation 1: Section coming from top
    tl.fromTo(
      sectionRef.current,
      { opacity: 0, y: -100 },
      { opacity: 1, y: 0, duration: 1.9, ease: 'power3.out' }
    );
    // Animation 5: Car Image Appearing (after section animation)
    tl.fromTo(
      imageRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.7, ease: 'power3.out' },
      '-=1' 
    );

    // Animation 2: Title Bouncing
    tl.fromTo(
      titleRef.current,
      { opacity: 0, y: 50, scale: 0.5 },
      { opacity: 1, y: 0, scale: 1, duration: 1.4, ease: 'bounce.out' },
      '-=0.5' 
    );

    // Animation 3: Subtitle Fading In
    tl.fromTo(
      subtitleRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out' },
      '-=1' 
    );

    // Animation 4: Floating Card Appearing
    tl.fromTo(
      floatingCardRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out' },
      '-=0.5' 
    );
    tl.fromTo(
      buttonRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' },
      '-=0.2'
    );
    tl.fromTo(
      CircleRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out' },
      '-=0.2'
    );


  }, [activeData]);

  return (
    <section
      ref={sectionRef}
      className="relative text-black p-6 lg:p-12 rounded-3xl m-6 mt-24 md:mt-28 lg:mt-36"
      style={{ backgroundColor: activeData.BgColor }}
    >
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* Cars Info */}
        <div className="flex flex-col justify-center text-center md:text-left">

          <h1
            ref={titleRef}
            className="text-4xl md:text-5xl lg:text-9xl font-bold tracking-tight leading-snug"
          >
            {activeData.title}
          </h1>

          <p
            ref={subtitleRef}
            className="lg:text-xl font-sans mt-4 text-gray-200"
          >
            {activeData.subtitle}
          </p>



          <div className="lg:justify-start flex justify-center items-center mt-6">
  <button
    ref={buttonRef}
    className="w-28 flex justify-center items-center font-medium bg-white text-black py-3 px-7 rounded-2xl shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
  >
    Details
  </button>
</div>

          <div className="flex justify-center md:justify-start space-x-3 mt-6"
            ref={CircleRef}
          >
            {carsData.map((car) => (
              <button

                key={car.id}
                onClick={() => handleActiveData(car)}
                style={{
                  backgroundColor: car.BgColor,
                  border: activeData.id === car.id ? '3px solid white' : 'none',
                  boxShadow:
                    activeData.id === car.id
                      ? '0 0 10px rgba(255, 255, 255, 0.5)'
                      : 'none',
                }}
                className="w-6 h-6 rounded-full focus:outline-none transition-all duration-300 transform hover:scale-125"
              />
            ))}
          </div>
        </div>

        {/* Hero Image */}
        <div className="flex justify-center">
          <img
            ref={imageRef}  // Attach the ref to the image
            src={activeData.image}
            alt=""
            className="w-[90%] max-w-[500px] md:max-w-[600px] lg:max-w-[800px]"
          />
        </div>
      </div>

      {/* WhatsApp Icon */}
      <div className="text-3xl text-white fixed bottom-6 right-6 z-[99999] mix-blend-difference">
        <a
          href="https://wa.me/yourphone"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:rotate-[360deg] duration-500"
        >
          <FaWhatsapp />
        </a>
      </div>

      {/* Floating Card */}
      <div
        ref={floatingCardRef}
        className="absolute left-[82%] top-1/3 transform -translate-x-1/2 -translate-y-1/2 bg-opacity-20 backdrop-blur-sm border shadow-lg rounded-xl p-4 w-[30%] hidden lg:block text-black"
      >
        <h2 className="text-2xl font-semibold text-center">
          {activeData.title}
        </h2>
        <p className="text-white mt-2 text-md text-center">
          {activeData.subtitle}
        </p>
        <div className="flex justify-between items-center mt-4">
          <span className="text-lg font-bold text-white">
            {activeData.price}
          </span>
          <button
            onClick={() => handleActiveData(activeData)}
            className="px-4 py-2 bg-black text-white rounded-lg hover:bg-slate-600 transition-all duration-300"
          >
            View Details
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
